<template>
  <div>
    <div class="nav-bar-box1">
      <div class="nav-bar-container">
        <div class="nav-bar-left">
          <img :src="getSetting.logo" alt style="height: 100px" />
          <div class="nav-item1">
            <ul>
              <li :class="`li ${$route.path === '/home' ? 'active' : ''}`" @click="$router.push('/home')">
                {{ $hs("首页", "Home", "En la primera página") }}
              </li>
              <li
                :class="`li ${$route.path === '/product' || $route.path === '/newproduct' ? 'active' : ''}`"
                @click="goProduct"
              >
                {{ $hs("产品", "Products", "productos") }}
              </li>
              <li :class="`li ${$route.path === '/classify' ? 'active' : ''}`" @click="typeRap('classify')">
                {{ $hs("类别", "Category", "categorías") }}
              </li>
              <li :class="`li ${$route.path === '/about' ? 'active' : ''}`" @click="typeRap('about')">
                {{ $hs("关于我们", "About Us", "Acerca de nosotros") }}
              </li>
              <li :class="`li ${$route.path === '/news' ? 'active' : ''}`" @click="typeRap('news')">
                {{ $hs("博客/新闻", "Blog", "El blog") }}
              </li>
              <li :class="`li ${$route.path === '/contact' ? 'active' : ''}`" @click="typeRap('contact')">
                {{ $hs("联系我们", "Contact Us", "Contacta con nosotros") }}
              </li>
              <!-- <li :class="`li ${ $route.path === '/personal' ? 'active' : '' }`" @click="goPersonal">{{ $hs('个人中心','Personal Center') }}</li> -->
            </ul>
          </div>
        </div>
        <div style="display: flex">
          <div>
            <img
              src="../../assets/LLH_follow/serch.png"
              alt
              style="width: 36px; height: 36px; margin-right: 12px; cursor: pointer"
              @click="getsercher"
            />
          </div>
          <div class="cart">
            <img
              src="../../assets/LLH_follow/shappcar.png"
              alt
              style="width: 36px; height: 36px; margin-right: 12px; cursor: pointer"
              @click="goCart"
            />
            <div class="cart-num">{{ userInfo.id ? gettingCart.length : getEnquiry[0].list.length }}</div>
          </div>
        </div>
      </div>
    </div>
    <login-modal ref="loginModal" @register="register" @forgetpassword="forgetpassword"></login-modal>
    <register-model ref="registerModel" @login="login"></register-model>
    <comprehensive-query ref="comprehensivequery" @login="login"></comprehensive-query>
    <reset-pass-model ref="resetPassModel" @login="login"></reset-pass-model>
  </div>
</template>

<script>
import loginModal from "@/components/memberModal/loginModal.vue";
import registerModel from "@/components/memberModal/registerModel.vue";
import ComprehensiveQuery from "@/components/memberModal/comprehensivequery.vue";
import resetPassModel from "@/components/memberModal/resetPassModel.vue";
import { mapGetters, mapState } from "vuex";
export default {
  name: "navBar",
  components: {
    loginModal,
    registerModel,
    ComprehensiveQuery,
    resetPassModel,
  },
  props: {
    tabHeight: {
      type: Number,
      default: 60,
    },
    menuBackground: {
      type: String,
      default: "#fe6a00",
    },
    textColor: {
      type: String,
      default: "#00923f",
    },
    activetextColor: {
      type: String,
      default: "#00923f",
    },
    hasSearchInput: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      keywords: "",
      active: this.$route.path,
    };
  },
  watch: {
    $route: {
      handler() {
        this.active = this.$route.path;
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters("setting", {
      getMenus: "get_menus",
      getSetting: "get_setting",
    }),
    ...mapGetters("operate", {
      gettingCart: "getting_cart",
      getEnquiry: "get_enquiry",
    }),
    ...mapState("user", ["userInfo"]),
  },
  methods: {
    // 登录
    login() {
      this.$refs.loginModal.open();
    },

    // 注册
    register() {
      this.$refs.registerModel.open();
    },
    goPersonal() {
      if (!this.userInfo.id) {
        this.login();
      } else {
        this.$router.push("/personal");
      }
    },
    // 跳转购物车
    goCart() {
      this.getScrollTop();
      if (!this.userInfo.id) {
        this.login();
      } else {
        this.$router.push({ path: "/cart" });
      }
    },
    getsercher() {
      this.getScrollTop();
      this.$refs.comprehensivequery.open();
    },
    // 打开忘记密码
    forgetpassword() {
      this.$refs.resetPassModel.open();
    },
    getScrollTop() {
      localStorage.setItem("scrollTop", JSON.stringify(0));
    },
    typeRap(typeLin) {
      this.getScrollTop();
      if (typeLin == "about") {
        this.$router.push("/about");
      } else if (typeLin == "news") {
        this.$router.push("/news");
      } else if (typeLin == "contact") {
        this.$router.push("/contact");
      } else if (typeLin == "classify") {
        this.$router.push("/classify");
      }
    },
    // 跳转产品页
    goProduct() {
      this.getScrollTop();
      if (this.$route.path === "/product") {
        this.$router.push("/product");
        location.reload();
      } else {
        this.$router.push("/product");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.nav-bar-box1 {
  margin-top: 62px;
  width: 100%;
  .nav-bar-container {
    width: 1200px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
  }
  .nav-bar-left {
    display: flex;
    align-items: center;
    height: 100%;
  }

  .nav-item1 {
    ul {
      display: flex;
      justify-content: space-between;
      margin: 10px 0;
      li {
        height: 100%;
        padding: 0 15px;
        line-height: 68px;
        font-size: 16px;
        color: #222;
        list-style: none;
        transition-duration: 0.5s;
        text-align: center;
        border-radius: 10px 10px 0 0;
        margin: 2px;
        box-sizing: border-box;
        cursor: pointer;
        &:hover {
          color: #e33c0b;
        }
      }

      .active {
        color: #e33c0b;
      }
    }
  }
  .cart {
    position: relative;
    width: 45px;
    height: 45px;
  }
  .cart-num {
    position: absolute;
    padding: 1px 6px;
    height: 20px;
    background: #e33c0b;
    font-size: 15px;
    border-radius: 50%;
    color: #fff;
    text-align: center;
    top: 0;
    right: 0;
  }
}
</style>
